import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// import Turbolinks from "turbolinks";
import "jquery"
import 'popper.js'
import "bootstrap/dist/js/bootstrap.bundle"
import "jquery.easing/jquery.easing"
import '@fortawesome/fontawesome-free/js/all'

import 'datatables.net';
import 'datatables.net-dt';  // Estilos DataTables

import './shared/sb-admin-2'
// Examples
import './shared/demo/datatables-demo'
import 'bootstrap-table';
import 'bootstrap-table/dist/locale/bootstrap-table-pt-BR.min.js';

$.noConflict(true);

require("packs/notify");
require('jquery')
global.$ = require('jquery')

Rails.start()
ActiveStorage.start()
// Turbolinks.start()

$(document).ready(function() {
    // Inicialização do DataTable
    $('#myTable').DataTable(); // Substitua #myTable com o seu seletor real

    // Lógica do evento change para a classe cbTipoPessoa
    $(".cbTipoPessoa").change(function() {
        $(".cnpj").prop("disabled", true);
        $(".cnpj").prop("required", false);
        $(".cpf").prop("disabled", true);
        $(".cpf").prop("required", false);
        if (this.value == 'Física') {
            $(".cnpj").prop("disabled", true);
            $(".cnpj").prop("required", false);
            $(".cpf").prop("disabled", false);
            $(".cpf").prop("required", true);
        }
        if (this.value == 'Jurídica') {
            $(".cnpj").prop("disabled", false);
            $(".cnpj").prop("required", true);
            $(".cpf").prop("disabled", true);
            $(".cpf").prop("required", false);
        }
    });

    // Forçando a troca de visibilidade ao carregar a página
    $(".cbTipoPessoa").trigger('change');

    // Funções para formatação dos campos
    $(".mskCpf").keyup(function() {
        this.value = formatarCpf(this.value);
    });

    $(".mskCnpj").keyup(function() {
        this.value = formatarCnpj(this.value);
    });

    $(".mascaraTelefone").keyup(function() {
        this.value = mascaraTelefone(this.value);
    });

    $(".mascaraCelular").keyup(function() {
        this.value = mascaraCelular(this.value);
    });

    $(".mascaraCep").keyup(function() {
        this.value = mascaraCep(this.value);
    });

    // Lógica de máscara para moeda
    $(".formatarMoeda").keyup(function() {
        var v = this.value.toString().replace(/\D/g, '');
        v = (v / 100).toFixed(2) + '';
        v = v.replace(".", ",");
        v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
        v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
        this.value = "R$ " + v;
    });

    // Lógica para formatação de número
    $(".formatarNumero").keyup(function() {
        var v = this.value.toString().replace(/\D/g, '');
        v = (v / 100).toFixed(2) + '';
        v = v.replace(".", ",");
        v = v.replace(/(\d)(\d{2})(\d{2}),/g, "$1,$3");
        this.value = v;
    });
});

function formatarCpf(campoTexto) {
    campoTexto = retirarFormatacao(campoTexto);
    campoTexto = mascaraCpf(campoTexto);
    return campoTexto;
}

function formatarCnpj(campoTexto) {
    campoTexto = retirarFormatacao(campoTexto);
    campoTexto = mascaraCnpj(campoTexto);
    return campoTexto;
}

function retirarFormatacao(campoTexto) {
    return campoTexto.replace(/(\.|\/|\-)/g,"");
}

function mascaraCpf(v) {
    v = v.replace(/\D/g, ""); // Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, "$1.$2"); // Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, "$1.$2"); // Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); // Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
}

function mascaraCnpj(v) {
    v = v.replace(/\D/g, ""); // Remove tudo o que não é dígito
    v = v.replace(/(\d{2})(\d)/, "$1.$2"); // Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, "$1.$2"); // Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, "$1/$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); // Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
}

function mascaraTelefone(v) {
    v = v.replace(/\D/g, ""); // Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2"); // Coloca parênteses em volta dos dois primeiros dígitos
    v = v.replace(/(\d)(\d{4})$/, "$1-$2"); // Coloca hífen entre o quarto e o quinto dígitos
    return v;
}

function mascaraCelular(v) {
    v = v.replace(/\D/g, ""); // Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2"); // Coloca parênteses em volta dos dois primeiros dígitos
    v = v.replace(/(\d)(\d{5})$/, "$1-$2"); // Coloca hífen entre o quarto e o quinto dígitos
    return v;
}

function mascaraCep(v) { // Máscara para CEP
    v = v.replace(/\D/g, ""); // Remove tudo o que não é dígito
    v = v.replace(/^(\d{5})(\d)/, "$1-$2"); // Esse é tão fácil que não merece explicações
    return v;
}
